import React from 'react';
import { assetUrl } from '../utils/webConfig';

interface IconProps {
  className?: string;
  onClick?: () => unknown;
}

export const GivelifyLogo: React.FC<IconProps> = React.memo(
  ({ className, onClick }) => (
    <svg
      xmlns={'http://www.w3.org/2000/svg'}
      onClick={onClick}
      className={className}
      width={'110'}
      height={'28'}
      viewBox={'0 0 110 28'}
      fill={'none'}
    >
      <path
        d={
          'M13.4622 20.7979C12.1801 20.7979 10.1035 19.3564 9.0774 18.5057C7.62721 17.3028 5.89807 15.4181 5.89807 13.2818C5.89807 10.613 7.95183 8.6001 10.6744 8.6001C11.862 8.6001 12.875 9.08385 13.5699 9.54326C14.2713 9.0871 15.2827 8.60172 16.4083 8.60172C16.8552 8.60172 18.2141 8.60172 19.4228 9.7267C19.9824 10.2478 20.0101 11.1211 19.4865 11.6763C18.9628 12.2331 18.0852 12.2607 17.5273 11.7396C17.1701 11.4052 16.7786 11.3598 16.4099 11.3598C15.6677 11.3598 14.7738 12.0497 14.5193 12.29L13.5193 13.2396L12.5569 12.2526C12.3138 12.0091 11.49 11.3582 10.676 11.3582C9.67933 11.3582 8.67284 11.9523 8.67284 13.2802C8.67284 15.0707 12.2274 17.6259 13.4263 18.0074C13.64 17.9035 14.0551 17.6665 15.1921 16.6763C15.7679 16.1747 16.6439 16.2315 17.148 16.8045C17.652 17.3776 17.595 18.2493 17.0191 18.7509C14.8626 20.6291 14.1115 20.7979 13.4622 20.7979Z'
        }
        fill={'#F85520'}
      />
      <path
        d={
          'M13.5359 27.2425C6.21803 27.2425 6.10352e-05 21.3189 6.10352e-05 14.0366C6.10352e-05 6.7543 5.95416 0.829102 13.272 0.829102C17.4089 0.829102 21.2358 2.69757 23.7708 5.95724C24.2389 6.5595 24.1296 7.42636 23.5228 7.89226C22.9176 8.35978 22.0465 8.2494 21.5784 7.64551C19.5719 5.06765 16.5443 3.58878 13.272 3.58878C7.48264 3.58878 2.7732 8.27537 2.7732 14.0366C2.7732 19.7978 7.74652 24.4844 13.5359 24.4844C19.4704 24.4844 23.0503 19.7357 23.0503 16.2573C21.9573 16.2656 20.8641 16.2849 19.7711 16.2849C19.0109 16.2849 18.3911 15.6746 18.3845 14.9165C18.378 14.1551 18.9946 13.5317 19.7597 13.5253C19.9408 13.5236 24.1918 13.4895 24.8688 13.4895C25.5458 13.4895 26.1234 13.8814 26.1234 14.5115C26.1234 14.8536 26.1234 15.3946 26.1234 15.3946C26.1234 20.56 21.9674 27.2425 13.5359 27.2425Z'
        }
        fill={'#F85520'}
      />
      <path
        d={
          'M43.539 8.0275H42.2724C41.236 8.0275 40.6379 8.73728 40.6379 9.60953V9.93107C39.6944 8.64834 38.2421 7.82227 36.539 7.82227C33.3836 7.82227 30.6664 10.5263 30.6664 13.781C30.6664 17.0357 33.3836 19.6935 36.539 19.6935C38.2662 19.6935 39.7167 18.8691 40.662 17.5847V18.7306C40.662 20.9078 39.0276 21.7099 36.9772 21.7099C35.549 21.7099 34.6278 21.3439 34.1673 21.1592C34.0985 21.137 34.0521 21.113 34.0057 21.0908C33.7754 20.93 33.5451 20.8616 33.3371 20.8616C32.6686 20.8616 32.1857 21.4123 32.1857 22.0537C32.1857 23.7725 35.8704 24.1163 37.0219 24.1163C40.0622 24.1163 43.1025 22.6044 43.1025 18.6844V11.419C43.1025 11.3267 43.1025 11.236 43.0801 11.1437V10.3415H43.5631C44.3914 10.3415 44.7833 9.74635 44.7833 9.19564C44.7833 8.62269 44.3674 8.0275 43.539 8.0275ZM36.8604 17.3777C34.7877 17.3777 33.1069 15.7273 33.1069 13.757C33.1069 11.809 34.7877 10.1363 36.8604 10.1363C38.933 10.1363 40.6603 11.809 40.6603 13.757C40.6603 15.7273 38.933 17.3777 36.8604 17.3777Z'
        }
        fill={'#050405'}
      />
      <path
        d={
          'M51.7929 18.3631C51.7929 18.936 51.3546 19.509 50.6191 19.509H46.6576C45.9203 19.509 45.5061 18.936 45.5061 18.3631C45.5061 17.7679 45.9203 17.1949 46.6576 17.1949H47.4172V10.3417H46.9102C46.1506 10.3417 45.7364 9.74655 45.7364 9.1736C45.7364 8.60065 46.1506 8.0277 46.9102 8.0277H48.6839C49.4676 8.0277 49.8577 8.60065 49.8577 9.1736C49.8577 9.17702 49.8577 9.18215 49.8577 9.18557C49.8577 9.18899 49.8577 9.19242 49.8577 9.19584V17.1949H50.6173C51.3564 17.1949 51.7929 17.7679 51.7929 18.3631ZM48.5223 6.46961C49.3507 6.46961 49.9969 5.80431 49.9969 4.95771C49.9969 4.11111 49.3524 3.4458 48.5223 3.4458C47.7163 3.4458 47.0718 4.11111 47.0718 4.95771C47.0718 5.82654 47.6939 6.46961 48.5223 6.46961Z'
        }
        fill={'#050405'}
      />
      <path
        d={
          'M63.1824 8.02783H62.0532C61.5239 8.02783 61.1544 8.23478 60.9241 8.71537L57.8151 16.3467L54.7061 8.71537C54.4758 8.27925 54.1303 8.02783 53.6233 8.02783C53.601 8.02783 53.601 8.02783 53.5769 8.02783H52.4478C51.7105 8.02783 51.2963 8.60078 51.2963 9.17373C51.2963 9.74668 51.7105 10.3419 52.4478 10.3419H52.7468L56.5691 18.8215C57.0984 19.7844 58.5266 19.7844 59.0559 18.8215L62.8782 10.3419H63.1772C63.9145 10.3419 64.3287 9.74668 64.3287 9.17373C64.3339 8.60078 63.9197 8.02783 63.1824 8.02783Z'
        }
        fill={'#050405'}
      />
      <path
        d={
          'M75.7217 14.696C75.0308 14.4206 74.4086 14.6276 73.9945 15.3151C73.2108 16.6218 71.8066 17.4701 70.1722 17.4701C68.952 17.4701 67.7764 16.7825 67.455 16.1873L74.6166 12.7274C75.0995 12.5205 75.5154 12.1545 75.5154 11.4892C75.5154 11.1454 75.3316 10.7093 75.0772 10.2748C74.156 8.69281 72.2672 7.82227 70.1481 7.82227C66.9016 7.82227 64.2412 10.4356 64.2068 13.6441C64.1707 16.9347 66.7624 19.6952 70.1722 19.6952C73.3964 19.6952 74.9861 18.2979 76.2287 16.3259C76.5724 15.7735 76.3438 14.9491 75.7217 14.696ZM70.1481 10.0217C71.2532 9.9533 72.2896 10.3432 72.9117 11.1454L66.6696 14.1692C66.3482 12.0382 67.9139 10.1585 70.1481 10.0217Z'
        }
        fill={'#050405'}
      />
      <path
        d={
          'M80.4761 17.1486C80.2235 17.1486 80.1771 16.9194 80.1771 16.6218V4.84127C80.1771 4.10755 79.7165 3.62695 79.0256 3.62695H76.9529C76.1932 3.62695 75.7791 4.17767 75.7791 4.77286C75.7791 5.34581 76.1932 5.94099 76.9529 5.94099H77.7366V16.2079C77.7366 16.4371 77.7366 16.6885 77.7589 16.9177C77.7813 18.4296 78.8176 19.6217 80.4761 19.6217C81.2598 19.6217 81.6963 18.9803 81.6963 18.3834C81.6963 17.7677 81.2598 17.1486 80.4761 17.1486Z'
        }
        fill={'#050405'}
      />
      <path
        d={
          'M88.5136 18.363C88.5136 18.936 88.0994 19.5089 87.3157 19.5089H83.8389C83.0792 19.5089 82.665 18.936 82.665 18.363C82.665 17.7678 83.0792 17.1949 83.8389 17.1949H84.3682V10.2836H83.8389C83.0792 10.2836 82.665 9.68837 82.665 9.11542C82.665 8.54246 83.0792 7.96951 83.8389 7.96951H85.6348C86.1195 7.96951 86.4632 8.20382 86.6488 8.52194C86.6557 8.53391 86.6626 8.54589 86.6677 8.55786C86.6763 8.57325 86.6849 8.58693 86.6918 8.60233C86.7365 8.69126 86.7691 8.79046 86.788 8.89821C86.7898 8.90334 86.7898 8.91018 86.7915 8.91531C86.7966 8.94268 86.8001 8.97175 86.8035 9.00083C86.807 9.03845 86.8087 9.07779 86.8087 9.11542V17.1949H87.3157C88.0976 17.1949 88.5136 17.7678 88.5136 18.363ZM85.4492 6.49181C86.2553 6.49181 86.8998 5.82651 86.8998 5.00214C86.8998 4.15383 86.2553 3.49023 85.4492 3.49023C84.6208 3.49023 83.9746 4.15554 83.9746 5.00214C83.9746 5.84874 84.5968 6.49181 85.4492 6.49181Z'
        }
        fill={'#050405'}
      />
      <path
        d={
          'M108.826 8.02744H107.052C107.049 8.02744 107.045 8.02744 107.042 8.02744C107.038 8.02744 107.033 8.02744 107.03 8.02744C106.454 8.02744 105.878 8.43962 105.878 9.17334V13.4816C105.878 15.9102 104.611 17.3777 102.816 17.3777C100.927 17.3777 99.5913 15.8418 99.5913 13.4354V9.17334C99.5913 9.16308 99.5896 9.15282 99.5896 9.14255C99.5896 9.12887 99.5913 9.1169 99.5913 9.10322C99.5913 8.53027 99.1771 7.95732 98.3934 7.95732H93.9026V7.17742C93.9026 6.00928 94.3409 5.82457 95.3068 5.80234C95.5147 5.91693 95.721 5.9631 95.9753 5.9631C96.5734 5.9631 97.2196 5.61933 97.2196 4.83944C97.2196 3.80813 96.1833 3.46436 95.3085 3.46436C93.1671 3.46436 91.4622 4.5179 91.4622 7.26806V7.95561H89.9652C89.2056 7.95561 88.7673 8.52856 88.7673 9.10151C88.7673 9.67446 89.2056 10.2696 89.9652 10.2696H91.4622V17.1912H90.7713C90.034 17.1912 89.6198 17.7642 89.6198 18.3594C89.6198 18.9323 90.034 19.5053 90.7713 19.5053H94.5488C95.2861 19.5053 95.7227 18.9323 95.7227 18.3594C95.7227 17.7642 95.2844 17.1912 94.5488 17.1912H93.9044V10.2731H97.1509V13.4594C97.1509 16.6679 99.2459 19.6934 102.816 19.6934C104.465 19.6934 105.375 19.0007 105.878 17.9523V18.6159C105.878 21.1831 104.104 21.7098 102.401 21.7098C101.502 21.7098 100.421 21.5268 99.5913 21.0685C99.4985 21.0223 99.4298 20.9761 99.4298 20.9761C99.1995 20.8154 98.9469 20.7008 98.7389 20.7008C98.0944 20.7008 97.541 21.2737 97.541 21.939C97.541 22.2366 97.6785 22.5582 97.9793 22.7873C99.3146 23.6579 100.88 24.1162 102.401 24.1162C104.658 24.1162 108.32 23.1311 108.32 18.6621V10.3415H108.827C109.565 10.3415 110.001 9.74629 110.001 9.17334C110.001 8.60039 109.563 8.02744 108.826 8.02744Z'
        }
        fill={'#050405'}
      />
    </svg>
  )
);

export const VerifiedIcon: React.FC<IconProps> = React.memo(
  ({ className, onClick }) => (
    <svg
      onClick={onClick}
      className={className}
      width={'18'}
      height={'21'}
      viewBox={'0 0 18 21'}
      fill={'none'}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <path
        fillRule={'evenodd'}
        clipRule={'evenodd'}
        d={
          'M0.664062 4.12168C0.664062 2.77736 1.55821 1.59864 2.87602 1.33297C4.48983 1.00762 6.77479 0.648438 8.9974 0.648438C11.22 0.648438 13.505 1.00762 15.1188 1.33297C16.4366 1.59864 17.3307 2.77736 17.3307 4.12168V11.6564C17.3307 13.3712 16.5509 14.9934 15.1936 16.0413C12.9089 17.8053 9.53999 20.3332 8.9974 20.3332C8.4548 20.3332 5.08585 17.8053 2.80115 16.0413C1.44385 14.9934 0.664062 13.3711 0.664062 11.6564V4.12168Z'
        }
        fill={'#715AFF'}
      />
      <path
        d={'M5.32812 10.093L8.0067 12.5577L13.0624 7.32031'}
        stroke={'white'}
        strokeWidth={'2'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
      />
    </svg>
  )
);

export const AddressIcon: React.FC<IconProps> = React.memo(
  ({ className, onClick }) => (
    <svg
      onClick={onClick}
      className={className}
      width={'24'}
      height={'24'}
      viewBox={'0 0 24 24'}
      fill={'none'}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <path
        d={
          'M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z'
        }
        stroke={'#73717F'}
        strokeWidth={'2'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
      />
      <path
        d={
          'M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z'
        }
        stroke={'#73717F'}
        strokeWidth={'2'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
      />
    </svg>
  )
);

export const PhoneIcon: React.FC<IconProps> = React.memo(
  ({ className, onClick }) => (
    <svg
      onClick={onClick}
      className={className}
      width={'22'}
      height={'22'}
      viewBox={'0 0 22 22'}
      fill={'none'}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <path
        d={
          'M20.9975 15.9201V18.9201C20.9986 19.1986 20.9416 19.4743 20.83 19.7294C20.7184 19.9846 20.5548 20.2137 20.3496 20.402C20.1443 20.5902 19.9021 20.7336 19.6382 20.8228C19.3744 20.912 19.0949 20.9452 18.8175 20.9201C15.7403 20.5857 12.7845 19.5342 10.1875 17.8501C7.77132 16.3148 5.72283 14.2663 4.18749 11.8501C2.49747 9.2413 1.44573 6.27109 1.11749 3.1801C1.0925 2.90356 1.12537 2.62486 1.21399 2.36172C1.30262 2.09859 1.44506 1.85679 1.63226 1.65172C1.81945 1.44665 2.0473 1.28281 2.30128 1.17062C2.55527 1.05843 2.82983 1.00036 3.10749 1.0001H6.10749C6.5928 0.995321 7.06328 1.16718 7.43125 1.48363C7.79922 1.80008 8.03957 2.23954 8.10749 2.7201C8.23411 3.68016 8.46894 4.62282 8.80749 5.5301C8.94204 5.88802 8.97115 6.27701 8.8914 6.65098C8.81164 7.02494 8.62635 7.36821 8.35749 7.6401L7.08749 8.9101C8.51105 11.4136 10.5839 13.4865 13.0875 14.9101L14.3575 13.6401C14.6294 13.3712 14.9726 13.1859 15.3466 13.1062C15.7206 13.0264 16.1096 13.0556 16.4675 13.1901C17.3748 13.5286 18.3174 13.7635 19.2775 13.8901C19.7633 13.9586 20.2069 14.2033 20.524 14.5776C20.8412 14.9519 21.0097 15.4297 20.9975 15.9201Z'
        }
        stroke={'#73717F'}
        strokeWidth={'2'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
      />
    </svg>
  )
);

export const CheckIcon: React.FC<IconProps> = React.memo(
  ({ className, onClick }) => (
    <svg
      onClick={onClick}
      className={className}
      width={'18'}
      height={'15'}
      viewBox={'0 0 18 15'}
      fill={'none'}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <path
        d={'M2 7.51197L6.42688 13.0239L16 2'}
        stroke={'#715AFF'}
        strokeWidth={'2.5'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
      />
    </svg>
  )
);

// cancel or remove
export const CrossIcon: React.FC<IconProps> = React.memo(
  ({ className, onClick }) => (
    <svg
      onClick={onClick}
      className={className}
      width={'24'}
      height={'24'}
      focusable={'false'}
      aria-hidden={'true'}
      viewBox={'0 0 24 24'}
    >
      <path
        d={
          'M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
        }
      ></path>
    </svg>
  )
);

export const RightArrowIcon: React.FC<IconProps> = React.memo(
  ({ className, onClick }) => (
    <svg
      onClick={onClick}
      className={className}
      width={'8'}
      height={'14'}
      viewBox={'0 0 8 14'}
      fill={'none'}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <path
        fillRule={'evenodd'}
        clipRule={'evenodd'}
        d={
          'M1.64191 13.2353L7.80523 7.44124C8.06492 7.19734 8.06492 6.80329 7.80523 6.55876L1.64191 0.76465C1.26702 0.411783 0.657084 0.411783 0.281531 0.76465C-0.0933552 1.11752 -0.0933552 1.69021 0.281531 2.04308L5.55392 7.00032L0.281531 11.9563C-0.0933552 12.3098 -0.0933552 12.8825 0.281531 13.2353C0.657084 13.5882 1.26702 13.5882 1.64191 13.2353Z'
        }
        fill={'#282636'}
      />
    </svg>
  )
);

export const StarIcon: React.FC<IconProps> = React.memo(
  ({ className, onClick }) => (
    <svg
      onClick={onClick}
      className={className}
      xmlns={'http://www.w3.org/2000/svg'}
      width={'13'}
      height={'13'}
      viewBox={'0 0 13 13'}
      fill={'none'}
    >
      <path
        d={
          'M6.02447 0.963526C6.17415 0.502871 6.82585 0.50287 6.97553 0.963525L8.0716 4.33688C8.13854 4.54289 8.33051 4.68237 8.54713 4.68237H12.0941C12.5784 4.68237 12.7798 5.30218 12.388 5.58688L9.51843 7.67173C9.34318 7.79905 9.26985 8.02474 9.33679 8.23075L10.4329 11.6041C10.5825 12.0648 10.0553 12.4478 9.66344 12.1631L6.79389 10.0783C6.61865 9.95095 6.38135 9.95095 6.20611 10.0783L3.33656 12.1631C2.9447 12.4478 2.41746 12.0648 2.56714 11.6041L3.66321 8.23075C3.73015 8.02474 3.65682 7.79905 3.48157 7.67173L0.612025 5.58688C0.220169 5.30218 0.421556 4.68237 0.905918 4.68237H4.45287C4.66949 4.68237 4.86146 4.54289 4.9284 4.33688L6.02447 0.963526Z'
        }
        fill={'#F85520'}
      />
    </svg>
  )
);

export const MessageIcon: React.FC<IconProps> = React.memo(
  ({ className, onClick }) => (
    <svg
      onClick={onClick}
      className={className}
      width={'18'}
      height={'16'}
      viewBox={'0 0 18 16'}
      fill={'none'}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <path
        d={
          'M1 3C1 1.89543 1.89543 1 3 1H15C16.1046 1 17 1.89543 17 3V10.0526C17 11.1572 16.1046 12.0526 15 12.0526H5.82068C5.29483 12.0526 4.79014 12.2597 4.41586 12.6291L2.70241 14.32C2.07056 14.9435 1 14.4959 1 13.6082V3Z'
        }
        stroke={'#715AFF'}
        strokeWidth={'2'}
      />
    </svg>
  )
);

export const DownloadBannerIcon: React.FC<IconProps> = React.memo(
  ({ className, onClick }) => (
    <svg
      onClick={onClick}
      className={className}
      width={'54'}
      height={'68'}
      viewBox={'0 0 54 68'}
      fill={'none'}
      xmlns={'http://www.w3.org/2000/svg'}
      xmlnsXlink={'http://www.w3.org/1999/xlink'}
    >
      <rect
        width={'54'}
        height={'68'}
        fill={'url(#pattern0)'}
      />
      <defs>
        <pattern
          id={'pattern0'}
          patternContentUnits={'objectBoundingBox'}
          width={'1'}
          height={'1'}
        >
          <use
            xlinkHref={'#image0_1530_268390'}
            transform={'translate(0 -0.00437202) scale(0.00900901 0.00715421)'}
          />
        </pattern>
        <image
          id={'image0_1530_268390'}
          width={'111'}
          height={'141'}
          xlinkHref={
            'data:image/png;base64,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'
          }
        />
      </defs>
    </svg>
  )
);

export const BarCodeIcon: React.FC<IconProps> = React.memo(
  ({ className, onClick }) => (
    <img
      onClick={onClick}
      className={className}
      src={assetUrl('/images/svg/downloadAppBarCode.svg')}
    />
  )
);

export const SecuredCheck: React.FC<IconProps> = React.memo(
  ({ className, onClick }) => (
    <svg
      onClick={onClick}
      className={className}
      width={'65'}
      height={'64'}
      viewBox={'0 0 65 64'}
      fill={'none'}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <circle
        cx={'32.5'}
        cy={'32'}
        r={'30'}
        fill={'#E8F9ED'}
      />
      <path
        fillRule={'evenodd'}
        clipRule={'evenodd'}
        d={
          'M37.5 20.5625V27L27.5 27L27.5 20.5625C27.5 18.0427 29.5427 16 32.0625 16L32.9375 16C35.4573 16 37.5 18.0427 37.5 20.5625ZM24.5 27L24.5 20.5625C24.5 16.3858 27.8858 13 32.0625 13H32.9375C37.1142 13 40.5 16.3858 40.5 20.5625V27H43.75C45.2688 27 46.5 28.2312 46.5 29.75V46.25C46.5 47.7688 45.2688 49 43.75 49H21.25C19.7312 49 18.5 47.7688 18.5 46.25V29.75C18.5 28.2312 19.7312 27 21.25 27H24.5ZM40.5 30H24.5H21.5V46H43.5V30H40.5ZM38.5308 33.9103C39.1326 34.4795 39.159 35.4289 38.5897 36.0308L32.9145 42.0308C32.3546 42.6226 31.4247 42.6594 30.8198 42.1137L27.4951 39.1137C26.8801 38.5587 26.8314 37.6102 27.3863 36.9951C27.9413 36.3801 28.8898 36.3314 29.5049 36.8864L31.7418 38.9048L36.4103 33.9692C36.9795 33.3674 37.9289 33.341 38.5308 33.9103Z'
        }
        fill={'#087D26'}
      />
    </svg>
  )
);

// Plus icon
export const AddIcon: React.FC<IconProps> = React.memo(
  ({ className, onClick }) => (
    <svg
      onClick={onClick}
      className={className}
      width={'24'}
      height={'24'}
      viewBox={'0 0 24 24'}
      fill={'none'}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <path
        d={'M12 5V19'}
        stroke={'#73717F'}
        strokeWidth={'2'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
      />
      <path
        d={'M5 12H19'}
        stroke={'#73717F'}
        strokeWidth={'2'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
      />
    </svg>
  )
);

export const MailIcon: React.FC<IconProps> = React.memo(
  ({ className, onClick }) => (
    <svg
      onClick={onClick}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M16 4C17.3807 4 18.5 5.11929 18.5 6.5V14.5C18.5 15.8807 17.3807 17 16 17H5C3.61929 17 2.5 15.8807 2.5 14.5V6.5C2.5 5.11929 3.61929 4 5 4H16ZM17.5 7.961L10.7535 11.931C10.6231 12.0077 10.4666 12.0205 10.3275 11.9693L10.2465 11.931L3.5 7.963V14.5C3.5 15.3284 4.17157 16 5 16H16C16.8284 16 17.5 15.3284 17.5 14.5V7.961ZM16 5H5C4.17157 5 3.5 5.67157 3.5 6.5V6.802L10.5 10.9199L17.5 6.801V6.5C17.5 5.67157 16.8284 5 16 5Z"
        fill="#73717F"
      />
    </svg>
  )
);

export const PlusIcon: React.FC<IconProps> = React.memo(
  ({ className, onClick }) => (
    <svg
      onClick={onClick}
      className={className}
      width={'25'}
      height={'24'}
      viewBox={'0 0 25 24'}
      fill={'none'}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <path
        d={'M12.5 5V19'}
        stroke={'#715AFF'}
        strokeWidth={'2'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
      />
      <path
        d={'M5.5 12H19.5'}
        stroke={'#715AFF'}
        strokeWidth={'2'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
      />
    </svg>
  )
);

export const SelectedCheckmark: React.FC<IconProps> = React.memo(
  ({ className, onClick }) => (
    <svg
      onClick={onClick}
      className={className}
      width={'33'}
      height={'32'}
      viewBox={'0 0 33 32'}
      fill={'none'}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <rect
        opacity={'0.12'}
        x={'0.5'}
        width={'32'}
        height={'32'}
        rx={'16'}
        fill={'#715AFF'}
      />
      <path
        d={'M11 16.9998L14.4783 21.1598L22 12.8398'}
        stroke={'#715AFF'}
        strokeWidth={'2.5'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
      />
    </svg>
  )
);

export const RecurringIcon: React.FC<IconProps> = React.memo(
  ({ className, onClick }) => (
    <svg
      onClick={onClick}
      className={className}
      xmlns={'http://www.w3.org/2000/svg'}
      width={'20'}
      height={'16'}
      viewBox={'0 0 20 16'}
      fill={'none'}
    >
      <path
        d={'M1.75 6.42725L3.78698 9.36851L6.12947 6.64837'}
        stroke={'#715AFF'}
        strokeWidth={'1.7'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
      />
      <path
        d={'M18.2503 10.2728L16.214 7.33154L13.8708 10.0517'}
        stroke={'#715AFF'}
        strokeWidth={'1.7'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
      />
      <path
        d={
          'M16.1873 7.35815C16.7969 10.4823 14.526 13.5447 11.43 14.2535C9.27092 14.7489 7.10604 14.0841 5.6333 12.6772'
        }
        stroke={'#715AFF'}
        strokeWidth={'1.7'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
      />
      <path
        d={
          'M3.79122 9.35246C2.83157 5.89169 5.23107 2.49541 8.56975 1.73139C10.8764 1.20197 13.186 1.99505 14.6537 3.60317'
        }
        stroke={'#715AFF'}
        strokeWidth={'1.7'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
      />
      <path
        fillRule={'evenodd'}
        clipRule={'evenodd'}
        d={
          'M9.59603 6.79519H10.9237C11.217 6.79519 11.4548 6.53557 11.4548 6.21532C11.4548 5.89506 11.217 5.63544 10.9237 5.63544H10.3927V5.3455C10.3927 5.02524 10.1549 4.76562 9.86157 4.76562C9.56826 4.76562 9.33048 5.02524 9.33048 5.3455V5.66443C8.66201 5.81264 8.20515 6.48981 8.2737 7.23082C8.34226 7.97184 8.91391 8.53557 9.59603 8.53482H10.1271C10.2738 8.53482 10.3927 8.66463 10.3927 8.82476C10.3927 8.98489 10.2738 9.1147 10.1271 9.1147H8.7994C8.50609 9.1147 8.26832 9.37432 8.26832 9.69458C8.26832 10.0148 8.50609 10.2745 8.7994 10.2745H9.33048V10.5644C9.33048 10.8846 9.56826 11.1443 9.86157 11.1443C10.1549 11.1443 10.3927 10.8846 10.3927 10.5644V10.2455C11.0611 10.0973 11.518 9.42008 11.4494 8.67907C11.3809 7.93806 10.8092 7.37432 10.1271 7.37507H9.59603C9.44937 7.37507 9.33048 7.24526 9.33048 7.08513C9.33048 6.925 9.44937 6.79519 9.59603 6.79519Z'
        }
        fill={'#715AFF'}
      />
    </svg>
  )
);

export const HomeIcon: React.FC<IconProps> = React.memo(
  ({ className, onClick }) => (
    <svg
      onClick={onClick}
      className={className}
      focusable={'false'}
      viewBox={'0 0 24 24'}
    >
      <path d={'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z'}></path>
    </svg>
  )
);

export const SmallCheckIcon: React.FC<IconProps> = React.memo(
  ({ className, onClick }) => (
    <svg
      width={'20'}
      height={'20'}
      viewBox={'0 0 20 20'}
      onClick={onClick}
      className={className}
      fill={'none'}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <rect
        opacity={'0.12'}
        width={'20'}
        height={'20'}
        rx={'10'}
        fill={'#F85520'}
      />
      <path
        d={'M6.5625 10L8.73641 12.5L13.4375 7.5'}
        stroke={'#F85520'}
        strokeWidth={'2'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
      />
    </svg>
  )
);
